'use client';

import { Button, ButtonList, ButtonVariant, ModalBody, ModalFooter } from '@bytel/trilogy-react';

import { CartContent } from '@components/cart-content';

import { useApp } from '@hooks/use-app';
import { useCart } from '@hooks/use-cart';

import { panierRoute } from '@helpers/routes';

export const CartModal = ({ onClose }: Readonly<{ onClose: () => void }>) => {
    const { goTo } = useApp();
    const { byouCart } = useCart();

    const updatedCart = () => {
        onClose();
        goTo(panierRoute.path);
    };

    if (!byouCart?.gencode) {
        return null;
    }

    return (
        <>
            <ModalBody>
                <CartContent cart={byouCart} />
            </ModalBody>
            <ModalFooter>
                <ButtonList>
                    <Button variant={ButtonVariant.SECONDARY} onClick={onClose}>
                        Fermer
                    </Button>
                    <Button variant={ButtonVariant.CONVERSION} onClick={updatedCart}>
                        Modifier ma commande
                    </Button>
                </ButtonList>
            </ModalFooter>
        </>
    );
};
